import { render, staticRenderFns } from "./AssessmentStudentTable.vue?vue&type=template&id=f0dca6ba&scoped=true"
import script from "./AssessmentStudentTable.vue?vue&type=script&lang=js"
export * from "./AssessmentStudentTable.vue?vue&type=script&lang=js"
import style0 from "./AssessmentStudentTable.vue?vue&type=style&index=0&id=f0dca6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0dca6ba",
  null
  
)

export default component.exports